// skeleton/app/src/app/shared/shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgbModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { SignaturePadModule } from 'angular2-signaturepad';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';

import { MaterialModule } from 'src/material-module';
import { NgChartsModule, ThemeService } from 'ng2-charts';

import { MenubarService } from './services/menunavbar.services';
import { CustomAttributeService } from './components/custom-attribute/custom-attribute.service';

import { ButtonComponent } from './components/inputs/button/button.component';
import { DropdownComponent } from './components/inputs/dropdown/dropdown.component';
import { TextComponent } from './components/inputs/text/text.component';

import { TableComponent } from './components/view/table/table.component';
import { ModalComponent } from './components/view/modal/modal.component';

import { HeaderComponent } from './components/base/header/header.component';
import { FooterComponent } from './components/base/footer/footer.component';

import { CardComponent } from './components/view/card/card.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { WelcomeComponent } from './components/welcome/welcome.component';

import { CheckboxListComponent } from './components/inputs/checkbox-list/checkbox-list.component';
import { RadiobuttonListComponent } from './components/inputs/radiobutton-list/radiobutton-list.component';
import { RatingComponent } from './components/inputs/rating/rating.component';

import { QuesChoiceResponseComponent } from './components/questions/ques-choice-response/ques-choice-response.component';
import { SectionComponent } from './components/section/section.component';
import { PageComponent } from './components/page/page.component';

import { CardWithCheckComponent } from './components/view/card-with-check/card-with-check.component';

import { RatingViewComponent } from './components/rating-view/rating-view.component';
import { RatingPreViewComponent } from './components/rating-preview/rating-preview.component';

import { GridComponent } from './components/inputs/grid/grid.component';

import { ExceptionComponent } from './components/error/exception.component';
import { ComingSoonComponent } from './components/coming-soon/comingsoon.component';

import { LoaderComponent } from './components/base/loader/loader.component';

import { SignatureComponent } from './components/inputs/signature/signature.component';

import { DrilldownchartComponent } from './components/drilldownchart/drilldownchart.component';

import { MenuNavbarComponent } from './components/menu-navbar/menu-navbar.component';

import { DashboardExpansionPanelComponent } from './components/dashboard-expansion-panel/dashboard-expansion-panel.component';

import { ShareDialogComponent } from './components/share-dialog/share-dialog.component';

import { CommonChartComponent } from './components/chart/common-chart/common-chart.component';

import { CommonMessageComponent } from './components/common-message/common-message.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';

import { CustomAttributeComponent } from './components/custom-attribute/custom-attribute.component';

import { AppHeaderComponent } from './components/appheader/headercomponent';

import { ContactComponent } from './components/contact/contactcomponent';
import { HelpComponent } from './components/help/helpcomponent';

import { ConsentDialogComponent } from './components/incident-consent-dialog/consent-dialog.component';

import { ConsentSignDialogComponent } from './components/incident-consent-sign-dialog/consent-sign-dialog.component';

import { DisputeSignatureComponent } from '../incident-dispute/dispute-signature/dispute-signature.component';

import { InputTypeMulComponent } from './components/QuestionTypes/QuesInputType-mul/inputType-mul.component';
import { InputTypeRadioComponent } from './components/QuestionTypes/QuesInputType-Radio/inputType-radio.component';
import { InputTypeDropdownComponent } from './components/QuestionTypes/QuesInputType-dropdown/inputType-dropdown.component';
import { InputTypeTextComponent } from './components/QuestionTypes/QuesInputType-text/inputType-text.component';
import { InputTypeDateComponent } from './components/QuestionTypes/QuesInputType-date/inputType-date.component';
import { InputTypeChkComponent } from './components/QuestionTypes/QuesInputType-chk/inputType-chk.component';
import { InputTypeFileUploadComponent } from './components/QuestionTypes/QuesInputType-fileUpload/inputType-fileUpload.component';
import { InputTypeRatingComponent } from './components/QuestionTypes/QuesInputType-rating/inputType-rating.component';
import { InputTypeMatrixComponent } from './components/QuestionTypes/QuesInputType-matrix/inputType-matrix.component';
import { InputTypeSignComponent } from './components/QuestionTypes/QuesInputType-sign/inputType-sign.component';
import { InputTypeGridComponent } from './components/QuestionTypes/QuesInputType-Grid/inputType-grid.component';
import { InputTypeDisplayTextComponent } from './components/QuestionTypes/QuesInputType-displaytext/input-type-display-text/input-type-display-text.component';
import { InputTypeDynamicGridComponent } from './components/QuestionTypes/QuesInputType-DynamicGrid/inputType-dynamic-grid.component';

import { QuesDirective } from './components/questions/ques.directive';
import { SectionDirective } from './components/section/section.directive';
import { HideIfUnAuthorizedDirective } from './directives/hide-if-un-authorized.directive';

import { GetArrayOfNumbers } from './numbers.pipe';

import { LogoutComponent } from '../logout/logout.component';

@NgModule({
  declarations: [
    ButtonComponent,
    DropdownComponent,
    TextComponent,
    TableComponent,
    ModalComponent,
    HeaderComponent,
    FooterComponent,
    CardComponent,

    CheckboxListComponent,
    RadiobuttonListComponent,
    RatingComponent,

    QuesChoiceResponseComponent,
    SectionComponent,
    PageComponent,

    ThankYouComponent,
    WelcomeComponent,

    LogoutComponent,

    CardWithCheckComponent,

    RatingViewComponent,
    RatingPreViewComponent,

    GridComponent,

    ExceptionComponent,
    ComingSoonComponent,
    LoaderComponent,

    SignatureComponent,

    DrilldownchartComponent,

    MenuNavbarComponent,
    DashboardExpansionPanelComponent,
    ShareDialogComponent,

    InputTypeMulComponent,
    InputTypeRadioComponent,
    InputTypeDropdownComponent,
    InputTypeTextComponent,
    InputTypeDateComponent,
    InputTypeChkComponent,
    InputTypeFileUploadComponent,
    InputTypeRatingComponent,
    InputTypeMatrixComponent,
    InputTypeSignComponent,
    InputTypeGridComponent,
    InputTypeDisplayTextComponent,
    InputTypeDynamicGridComponent,

    CommonChartComponent,
    CommonMessageComponent,
    MessageDialogComponent,

    CustomAttributeComponent,
    AppHeaderComponent,

    ContactComponent,
    HelpComponent,

    ConsentDialogComponent,
    ConsentSignDialogComponent,
    DisputeSignatureComponent,

    QuesDirective,
    SectionDirective,
    HideIfUnAuthorizedDirective,
  ],

  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,

    RouterModule,

    DragDropModule,

    FontAwesomeModule,

    NgChartsModule,

    NgMultiSelectDropDownModule.forRoot(),

    NgbModule,
    NgbRatingModule,

    SignaturePadModule,

    MatSidenavModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDividerModule,
    MatExpansionModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,

    MaterialModule,

    GetArrayOfNumbers,
  ],

  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    ButtonComponent,
    DropdownComponent,
    TextComponent,

    TableComponent,
    ModalComponent,

    HeaderComponent,
    FooterComponent,

    CardComponent,

    CheckboxListComponent,
    RadiobuttonListComponent,
    RatingComponent,

    QuesChoiceResponseComponent,
    SectionComponent,
    PageComponent,

    ThankYouComponent,
    WelcomeComponent,

    CardWithCheckComponent,

    RatingViewComponent,
    RatingPreViewComponent,

    ExceptionComponent,
    ComingSoonComponent,
    LoaderComponent,

    DrilldownchartComponent,

    MenuNavbarComponent,
    DashboardExpansionPanelComponent,
    ShareDialogComponent,

    InputTypeMulComponent,
    InputTypeRadioComponent,
    InputTypeDropdownComponent,
    InputTypeTextComponent,
    InputTypeDateComponent,
    InputTypeChkComponent,
    InputTypeFileUploadComponent,
    InputTypeRatingComponent,
    InputTypeMatrixComponent,
    InputTypeSignComponent,
    InputTypeGridComponent,
    InputTypeDisplayTextComponent,
    InputTypeDynamicGridComponent,

    CommonChartComponent,

    CommonMessageComponent,
    MessageDialogComponent,

    AppHeaderComponent,
    CustomAttributeComponent,

    ContactComponent,
    HelpComponent,

    ConsentDialogComponent,
    ConsentSignDialogComponent,
    DisputeSignatureComponent,

    QuesDirective,
    SectionDirective,
    GetArrayOfNumbers,
    HideIfUnAuthorizedDirective,

    MatSidenavModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDividerModule,
    MatExpansionModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
  ],

  providers: [
    DatePipe,
    ThemeService,
    MenubarService,
    CustomAttributeService,
  ],
})
export class SharedModule {}